import { handleRangeDate2SingleDateRangeTimeFilterExtend } from '@intelligence/utils/dateUtils';
import {
  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // 品类筛选器
  GENRETOR as GENRE_SELECT_FILTER,
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // Product Model筛选器
  SENSOR_TOWER_TAG_PRODUCT_MODEL,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { handleExtendTimeFilterValue } from '@intelligence/utils/filterUtils';

export const getInitialFormValue = (isOperate: boolean, filterExtendTmp: any, defaultFormValue: any) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue || {};

  const filterExtend = handleRangeDate2SingleDateRangeTimeFilterExtend(filterExtendTmp);

  /** 各个筛选器的继承值 **/
  const singleSourceExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];
  const regionFilterExtend = filterExtend?.[REGION_SELECT_FILTER];
  const genreFilterExtend = filterExtend?.[GENRE_SELECT_FILTER];
  const rangeTimeFilterExtend = filterExtend?.[RANGE_TIME_SELECT_FILTER];
  const productModelFilterExtend = filterExtend?.[SENSOR_TOWER_TAG_PRODUCT_MODEL];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const singleSourceDefault = defaultFormValue?.[SINGLE_SOURCE_SELECT_FILTER];
  const regionDefault = defaultFormValue?.[REGION_SELECT_FILTER];
  const genreDefault = defaultFormValue?.[GENRE_SELECT_FILTER];
  const rangeTimeDefault = defaultFormValue?.[RANGE_TIME_SELECT_FILTER];
  const productModelDefault = defaultFormValue?.[SENSOR_TOWER_TAG_PRODUCT_MODEL];
  /** 各个筛选器的默认值 **/

  return {
    // 单数据源筛选器
    [SINGLE_SOURCE_SELECT_FILTER]: {
      value: singleSourceExtend?.value || singleSourceDefault?.value,
    },
    // 级联国家筛选器
    [REGION_SELECT_FILTER]: {
      type: regionFilterExtend?.filterType || regionDefault?.type,
      regions: regionFilterExtend?.filterRegions || regionDefault?.regions,
      markets: regionFilterExtend?.filterMarkets || regionDefault?.markets,
    },
    // 级联品类筛选器
    [GENRE_SELECT_FILTER]: {
      source: genreFilterExtend?.genretor?.source || genreDefault?.source,
      mainGenres: genreFilterExtend?.genretor?.mainGenres || genreDefault?.mainGenres,
      subGenres: genreFilterExtend?.genretor?.subGenres || genreDefault?.subGenres,
      level3Genres: genreFilterExtend?.genretor?.level3Genres || genreDefault?.level3Genres,
      level4Genres: genreFilterExtend?.genretor?.level4Genres || genreDefault?.level4Genres,
    },
    // 日期筛选器
    [RANGE_TIME_SELECT_FILTER]: {
      type: 'daily', // rangeTimeFilterExtend?.filterType || rangeTimeDefault?.type,
      value: handleExtendTimeFilterValue({
        // 仅有天粒度，单选1天
        needSameDay: true,
        extendFilterValues: rangeTimeFilterExtend,
        defaultValue: rangeTimeDefault?.value,
      }),
      // value: rangeTimeFilterExtend?.filterValue || rangeTimeDefault?.value,
    },
    // Product Model筛选器
    [SENSOR_TOWER_TAG_PRODUCT_MODEL]: {
      value: productModelFilterExtend?.value || productModelDefault?.value || [],
    },
  };
};
